import apple from "../../../assets/apple-logo.png";
import google from "../../../assets/google-play.png";
import map from "../../../assets/world-map.png";

const HeroSection = () => {
  return (
    <div className="max-lg:px-6 lg:ml-16 py-14 lg:py-10">
      <div className="lg:grid grid-cols-2 gap-8">
        <div className="flex items-center">
          <div>
            <h1 className="text-3xl leading-[42.3px] lg:text-6xl lg:leading-[81px] font-semibold text-primary">
              Connecting You to Easy Mobility and Logistics Solutions
            </h1>
            <span className="lg:max-w-[500px] text-paragraph font-medium mt-5">
              Hassle-free mobility and logistics. Book, track, and simplify your
              transportation and logistics today
            </span>
            <div className="lg:max-w-[350px] flex items-center space-x-5 mt-7">
              <div className="download-btn">
                <div className="w-5 sm:w-7">
                  <img className="w-full" alt="" src={apple} />
                </div>
                <div>
                  <span className="text-xs text-paragraph">
                    Download on the
                  </span>
                  <h1 className="max-sm:text-xs font-medium text-primaryBlack -mt-1">
                    App Store
                  </h1>
                </div>
              </div>
              <div className="download-btn">
                <div className="w-5 sm:w-7">
                  <img className="w-full" alt="" src={google} />
                </div>
                <div>
                  <span className="text-xs text-paragraph">Get it on</span>
                  <h1 className="max-sm:text-xs font-medium text-primaryBlack -mt-1">
                    Google Play
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-lg:hidden">
          <img src={map} alt="" />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
